import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const sitemapSkipped = (provider: string) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:skipped`, 
        category: settings.categoryName 
    });
};

export default sitemapSkipped;